import cachedFetch from '../utility-functions/cached-fetch';

const QUICK_BASKET_URL = '/basket/quickbasket';
const QUICK_BASKET_COUNT_URL = '/basket/api/getcurrent';
const BASKET_TOTAL_URL = '/basket/api/getcurrent';
const cacheBuster = () => new Date().getTime();

export const getQuickbasketHTML = () => {
  return fetch(`${QUICK_BASKET_URL}?c=${cacheBuster()}`, {
    credentials: 'include'
  })
    .then((response) => {
      return response.text();
    })
    .catch((err) => {
      return { message: 'server error', err };
    });
};

export const getQuickBasketCount = (cacheBuster: boolean = false) => {
  return cachedFetch(`${QUICK_BASKET_COUNT_URL}`, { seconds: 60, cacheBuster, request: { credentials: 'include' } })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json.basket.items.reduce((r, d) => r + d.quantity, 0);
    })
    .catch((err) => {
      return { message: 'server error', err };
    });
};

export const getBasketTotal = (cacheBuster: boolean = false) => {
  return cachedFetch(`${BASKET_TOTAL_URL}`, { seconds: 60, cacheBuster, request: { credentials: 'include' } })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json.currency.symbol + json.basket.total.toFixed(2);
    })
    .catch((err) => {
      return { message: 'server error', err };
    });
};
